<div class="row" *ngIf="pageReady">
    <div class="col-md-12">
                
    </div>
</div>